<template>
	<div style="width:100%;">
		<el-tabs v-model="editableTabsValue" type="card" closable @tab-click="handleTabsEdit" @tab-remove="removeTab">
			<el-tab-pane v-for="(item,index) in editableTabs" :label="item" :name="item" :key="index"></el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				editableTabsValue: "1",
				editableTabs: [],
				tabIndex: 2
			};
		},
		props: {
			textList: {
				type: Array,
				default: () => []
			},
			texttit: {
				type: String,
				default: ""
			}
		},
		watch: {
			textList(newV) {
				this.editableTabs = newV;
				//把数组中最后一个赋值给tabs 高亮
				this.editableTabsValue = newV[newV.length - 1]
				this.getlist();
			},
			texttit(newV) {
				this.editableTabsValue = newV;
			}
		},
		mounted() {
			this.getlist();
		},
		methods: {
			getlist() {
				this.editableTabs = this.textList;
			},
			//跳转页面
			handleTabsEdit(tab) {
				this.$router.push({
					name: tab.name
				});
			},
			// 跳转页面
			jump(name) {
				this.$router.push({
					name: name
				});
				this.editableTabsValue = name;
			},
			// 删除tabs
			removeTab(targetName) {
				let tabs = this.editableTabs;
				let activeName = this.editableTabsValue;
				if (activeName === targetName) {
					tabs.forEach((tab, index) => {
						if (tab === targetName) {
							let nextTab = tabs[index + 1] || tabs[index - 1];
							if (nextTab) {
								activeName = nextTab;
							}
						}
					});
				}
				this.editableTabsValue = activeName;
				this.editableTabs = tabs.filter(tab => tab !== targetName);
				if (this.editableTabs.length == 0) {
					this.$message({
						message: "跳转到老人数据列表",
						type: "warning"
					});
					this.editableTabs=["老人数据列表"]
					this.$router.push("/");
					this.$emit("GetArrayList", this.editableTabs);
				} else {
					this.$emit("GetArrayList", this.editableTabs);
					this.jump(this.editableTabsValue);
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
</style>
